import React, { useState } from "react";
import { Button, Checkbox, Modal, notification } from "antd";

import { acceptTnCUpdate } from "../../graphQl/mutations/users";
import { captureException } from "../../utils/sentry";

// solo se muestran URLs http(s) de los T&C (Countries.termsandconditions)
const isValidUrl = url => /^https?:\/\//i.test(url || "");

/**
 * Modal bloqueante para que el afiliado acepte la version vigente de los T&C.
 * No se puede cerrar: solo aceptar los nuevos T&C o cerrar sesion.
 */
const TnCUpdateModal = ({ client, tncStatus, onAccepted, onLogout }) => {
  const [checked, setChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const { currentVersion, termsUrl } = tncStatus || {};
  const showTerms = isValidUrl(termsUrl);

  const onAccept = async () => {
    try {
      setLoading(true);
      const {
        data: { AcceptTnCUpdate: response },
      } = await client.mutate({ mutation: acceptTnCUpdate });

      if (response.statusCode === 200) {
        notification.success({ message: response.message });
        onAccepted();
      } else {
        notification.error({ message: response.message });
        setLoading(false);
      }
    } catch (error) {
      captureException(error);
      notification.error({
        message: "Hubo un error al aceptar los Términos y Condiciones.",
      });
      setLoading(false);
    }
  };

  return (
    <Modal
      visible
      centered
      width={800}
      closable={false}
      maskClosable={false}
      keyboard={false}
      title="Actualización de Términos y Condiciones"
      footer={[
        <Button key="logout" onClick={onLogout} disabled={loading}>
          Cerrar sesión
        </Button>,
        <Button
          key="accept"
          type="primary"
          onClick={onAccept}
          loading={loading}
          disabled={!checked}
        >
          Acepto los nuevos Términos y Condiciones
        </Button>,
      ]}
    >
      <p>
        Hemos actualizado nuestros Términos y Condiciones
        {currentVersion ? ` (versión ${currentVersion})` : ""}. Para continuar
        usando la plataforma debes leerlos y aceptarlos.
      </p>
      {showTerms && (
        <>
          <iframe
            title="Términos y Condiciones"
            src={termsUrl}
            style={{
              width: "100%",
              height: "50vh",
              border: "1px solid #f0f0f0",
              borderRadius: 4,
            }}
          />
          <p style={{ marginTop: 8 }}>
            Si no puedes visualizar los Términos y Condiciones,{" "}
            <a href={termsUrl} target="_blank" rel="noopener noreferrer">
              ábrelos en una nueva pestaña
            </a>
            .
          </p>
        </>
      )}
      <Checkbox
        checked={checked}
        disabled={loading}
        onChange={e => setChecked(e.target.checked)}
      >
        He leído y acepto los nuevos Términos y Condiciones.
      </Checkbox>
    </Modal>
  );
};

export default TnCUpdateModal;
